<template>
	<div id='dom' class="page">
		<!-- <Tip :tip="tip" /> -->
		<div class="from_div">
			<el-form ref="form" :model="form" label-position="left" label-width="110px">
				<el-form-item label="企业简称：" prop="company_name">
					<el-input class="input" v-model="form.company_name" placeholder="请输入内容"/>
				</el-form-item>
				<el-form-item label="企业公司名称：" prop="company_company">
					<el-input class="input" v-model="form.company_company" placeholder="请输入内容"/>
				</el-form-item>
				<el-form-item label="企业LOGO：" prop="company_logo" style="margin-bottom: 0;">
					<multiUpload :type='0' :limitImg='1' :noneBtnImg='logoList.length > 0' :fileList="logoList" @saveImg="saveImg" @delImg="delImg"/>
				</el-form-item>
				<el-form-item label="执照证件：" prop="company_licenses" style="margin-bottom: 0;">
					<div class="row">
						<multiUpload :type='1' :limitImg='1' :noneBtnImg='licenses.length > 0' :fileList="licenses" @saveImg="saveImg" @delImg="delImg"/>
						<multiUpload :type='2' :limitImg='1' :noneBtnImg='licenses1.length > 0' :fileList="licenses1" @saveImg="saveImg" @delImg="delImg"/>
					</div>
				</el-form-item>
				<el-form-item label="服务电话：" prop="company_licenses">
					<el-input class="input_s" v-model="form.company_phone" placeholder="请输入内容"/>
				</el-form-item>
				<el-form-item label="收款信息：" prop="company_collection" style="margin-bottom:0">
					<div class="add_div" v-for="(item,index) in form.company_collection">
						<div class="item_div">
							<el-input class="input" v-model="item.bank" placeholder="开户银行" />
							<el-input class="input" v-model="item.account" placeholder="银行账户" />
							<el-input class="input" v-model="item.name" placeholder="账号户名" />
							<el-button type="primary" plain @click="addItem(index+1)">添加</el-button>
							<el-button v-if="index != 0" type="danger" plain @click="deleteItem(index)">删除</el-button>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="税务证号：" prop="company_tax_no">
					<el-input class="input_" v-model="form.company_tax_no" placeholder="请输入内容"/>
				</el-form-item>
				<el-form-item label="经营地址：" prop="company_address">
					<el-input class="input_" v-model="form.company_address" placeholder="请输入内容"/>
				</el-form-item>
				<el-form-item label="主营类目：" prop="company_cates">
					<el-input class="input_" v-model="form.company_cates" placeholder="请输入内容"/>
				</el-form-item>
				<el-form-item label="其他备注：" prop="company_remark">
					<el-input class="input_" v-model="form.company_remark" placeholder="请输入内容"/>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button type="primary" @click="submitForm('form')">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import multiUpload from "../../../components/multiUpload/multiUpload.vue"
	import {
		firmInfoDeatail,
		firmInfoEdit
	} from "../../../request/apis.js"
	import {
		mapGetters
	} from 'vuex';
	export default {
		components: {
			Tip,
			multiUpload
		},
		data() {
			return {
				tip: '本公司档案信息管理。',
				logoList:[],//企业logo图片
				licenses:[],
				licenses1:[],
				form: {
					company_name: '', //企业简称
					company_company: '', //企业公司名称
					company_logo: '', //企业LOGO
					company_licenses: [], //执照证件
					company_phone: '', //服务电话
					company_collection: [{
						bank: '', //开户银行
						account: '', //银行账户
						name: '' //账号户名
					}],
					company_tax_no: '', //税务证号
					company_address: '', //经营地址
					company_cates: '', //主营类目
					company_remark: '' //其他备注
				}
			}
		},
		computed: {
			...mapGetters(['loginInfo']),
		},
		mounted() {
			this.$watermark.set(this.loginInfo.nick_name + '-' + this.loginInfo.phone.substr(this.loginInfo.phone.length-4), dom);
			this.getFirmInfoDeatail();
		},
		methods: {
			
			//获取公司信息
			getFirmInfoDeatail(){
				firmInfoDeatail().then(res=>{
					if(res.code == 0){
						if(typeof(res.data.company_name) !== 'undefined'){
							if(res.data.company_logo != ''){
								this.logoList.push({url:res.data.company_logo})
							}
							if(res.data.company_licenses[0] != ''){
								this.licenses.push({url:res.data.company_licenses[0]})
							}
							if(res.data.company_licenses[1] != ''){
								this.licenses1.push({url:res.data.company_licenses[1]})
							}
							for (var key in res.data) {
								if (this.form.hasOwnProperty(key)) {
									if(key != 'company_collection'){
										this.form[key] = res.data[key];
									}else if(res.data['company_collection'].length > 0){
										this.form[key] = res.data[key];
									}
								}
							}
						}
					}
				}).catch(err=>{})
			},
			
			//添加收款信息条目
			addItem(index) {
				var obj = {
					bank: '', //开户银行
					account: '', //银行账户
					name: '' //账号户名
				}
				this.form.company_collection.splice(index, 0, obj)
			},

			//移除收款信息条目
			deleteItem(index) {
				this.form.company_collection.splice(index, 1)
			},
			
			//图片存储
			saveImg(arr){
				if(arr[1] == 0){
					//企业logo
					this.form.company_logo = arr[0];
				}else{
					//执照证件
					this.form.company_licenses.splice(arr[1] - 1, 0, arr[0]);
				}
			},
			
			//图片删除
			delImg(arr){
				switch (arr[1]){
					case 0:
					//企业logo
					this.form.company_logo = '';
					this.logoList = []
						break;
					case 1:
					//执照证件
					this.form.company_licenses.splice(0, 1);
					this.licenses = []
						break;
					case 2:
					//执照证件
					this.form.company_licenses.splice(1, 1);
					this.licenses1 = []
						break;
				}
				
			},

			//提交表单
			submitForm(form) {
				this.$refs[form].validate((valid) => {
					if (valid) {
						//编辑
						firmInfoEdit({...this.form}).then(res=>{
							if(res.code == 0){
								this.logoList = [],//企业logo图片
								this.licenses = [],
								this.licenses1 = [],
								this.$message.success(res.msg);
								this.getFirmInfoDeatail();
							}else{
								this.$message.error(res.msg);
							}
						}).catch(err=>{})
					} else {
						return false;
					}
				});
			},
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		min-height: -webkit-fill-available;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.from_div {
		margin-top: 20px;
		width: 100%;
	}

	.input {
		width: 200px;
		margin-right: 25px;
	}

	.input_s {
		width: 130px;
	}

	.input_ {
		width: 435px;
	}

	.add_div {
		display: flex;
		flex-direction: column;
	}

	.item_div {
		display: flex;
		flex-direction: row;
		margin-bottom: 22px;
	}

	.upload_div {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 90px;
		height: 90px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
	}

	.upload_div_ {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 160px;
		height: 90px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		margin-right: 25px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		margin-left: 66px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #606266;
		margin-left: 100px;
	}

	.span_ {
		font-size: 12px;
		font-weight: normal;
		line-height: normal;
		color: #767676;
		margin-top: 5px;
	}

	.el-icon-plus {
		font-size: 20px;
		font-weight: bolder;
		color: #606266;
	}
</style>